<template>
    <div id="workWithUs">
        <emojis/>
        
        <div class="container">
            <div class="row first-camp">
                    <div class="col-md-5 flex j-c-center text-center">
                        <div>
                            <h1 class="color-white big-title f-w-700">Ficha de <br> pré-qualificação</h1>
                        </div>    
                    </div>
                    <div class="col-md-7 col-12 in-992 flex j-c-center">
                        <p class="toDescriptions color-white">
                            Para conhecê-lo melhor como um candidato
                            a franqueado Ponto Fácil, por favor
                            preencha os campos abaixo:
                        </p>
                    </div>
                </div>
           <validationObserver
                ref="formulario"
                class="row relative"
                tag="form"
               @submit.prevent="onSubmit()"
            >
                <div class="sendigSvg" v-show="svgSending">
                    <img class="img-responsive" src="@/lib/SVG-Loaders-master/ball-triangle.svg" alt="ball-triangle">
                </div>
                <div class="collapsers row">
                    <div class="col-md-8 mx-auto">
                       <ValidationProvider
                            tag="div"
                            class="col-md-12"
                            rules="required"
                            name="Nome completo"
                            v-slot="{ errors, ariaMsg, classes }"
                            >
                           <label :class="classes">Nome completo</label>
                            <input id="fullName" class="form-control" type="text" v-model="form.FromName" :class="classes">
                            <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <div class="row mx-0">
                            <ValidationProvider
                                tag="div"
                                class="col-md-6"
                                rules="required|email"
                                name="Endereço de Email"
                                v-slot="{ errors, ariaMsg, classes }"
                                >
                                <label :class="classes">Endereço de Email</label>
                                <input id="email" type="email" v-model="form.From"  :class="classes"  class="form-control">
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                            </ValidationProvider>
                            <ValidationProvider
                                tag="div"
                                class="col-md-6"
                                rules="required"
                                name="Data de nascimento"
                                v-slot="{ errors, ariaMsg, classes }"
                                >
                                <label :class="classes">Data de nascimento</label>
                                <input id="birthday" type="date" v-model="form.birthday"  :class="classes"  class="form-control">
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="row mx-0">
                            <ValidationProvider
                            tag="div"
                            class="col-md-6"
                            rules="required"
                            name="CPF"
                            v-slot="{ errors, ariaMsg, classes }"
                            >  
                                <label :class="classes">CPF</label>
                                <input id="cpf"  v-mask="['###.###.###-##']"  type="text" v-model="form.cpf" :classes="classes" class="form-control" >
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                            </ValidationProvider>     
                            <ValidationProvider class="col-md-6" rules="required" tag="div" name="RG"
                             v-slot="{ errors, ariaMsg, classes }">
                                <label :class="classes">RG</label>
                                <input id="rg"  class="form-control" type="number" v-model="form.rg" :class="classes">
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                            </ValidationProvider>  
                        </div>
                            <ValidationProvider
                                class="col-md-12" 
                                rules="required" tag="div"
                                name="Endereço Residencial"
                                v-slot="{ errors, ariaMsg, classes }"
                            >
                                <label :class="classes">Endereço Residencial</label>
                                <input id="adress_res" type="text" v-model="form.Residencia" class="form-control"  :class="classes">
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                            </ValidationProvider>
                            <div class="row mx-0" style="margin-top:-10px">
                                <ValidationProvider 
                                    class="col-md-6" 
                                    rules="required" 
                                    tag="div" 
                                    name="Número residencial"
                                    v-slot="{ errors, ariaMsg, classes }"
                                >
                                    <label :class="classes">Número</label>
                                    <input id="number_res"  type="number" v-model="form.numeroResidencia" class="form-control" :class="classes">
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                                </ValidationProvider>
                                <ValidationProvider 
                                    class="col-md-6" 
                                    rules="required" 
                                    tag="div" 
                                    name="CEP residencial"
                                    v-slot="{ errors, ariaMsg, classes }"
                                > 
                                <label :class="classes">CEP</label>
                                <input id="cep_res" type="number"  v-model="form.cepCasa" class="form-control" :class="classes">
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                                </validationProvider>
                            </div>
                            <ValidationProvider 
                                class="col-md-12"  
                                tag="div" 
                                name="Complemento Residencial"
                                v-slot="{ errors, ariaMsg, classes }"
                            >
                                <label :class="classes">Complemento</label>
                                <input id="comple_res" type="text" v-model="form.complemento" class="form-control" :class="classes">
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                            </ValidationProvider>
                            <ValidationProvider 
                                class="col-md-12" 
                                rules="required" 
                                tag="div" 
                                name="Estado Civil"
                                v-slot="{ errors, ariaMsg, classes }"
                            >
                                <label :class="classes">Estado Civil</label>
                                <input id="civil" type="text" v-model="form.estadoCivil" class="form-control" :class="classes">
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                            </validationProvider>
                            <ValidationProvider 
                                class="col-md-12" 
                                rules="required" 
                                tag="div" 
                                name="Nome da Lotérica"
                                v-slot="{ errors, ariaMsg, classes }"
                            >
                                <label :class="classes">Nome da Lotérica</label>
                                <input id="nameLot" type="text" v-model="form.nomeLoterica" class="form-control" :class="classes">
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                            </validationProvider>
                            <ValidationProvider 
                                class="col-md-12" 
                                rules="required" 
                                tag="div" 
                                name="Endereço da Lotérica"
                                v-slot="{ errors, ariaMsg, classes }"
                            >
                                <label :class="classes">Endereço da Lotérica</label>
                                <input id="adress_lot" type="text" v-model="form.enderecoLoterica" class="form-control" :class="classes">
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                            </validationProvider>
                            <div class="row mx-0">
                                <ValidationProvider 
                                class="col-md-6" 
                                rules="required" 
                                tag="div" 
                                name="Número"
                                v-slot="{ errors, ariaMsg, classes }"
                                >
                                    <label :class="classes">Número</label>
                                    <input id="number_lot" type="number" v-model="form.numeroLoterica" class="form-control" :class="classes">
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                                </validationProvider>
                               <ValidationProvider 
                                class="col-md-6" 
                                rules="required" 
                                tag="div" 
                                name="CEP"
                                v-slot="{ errors, ariaMsg, classes }"
                                >
                                <label :class="classes">CEP</label>
                                <input id="cep_lot"  type="number" v-model="form.cepLoterica" class="form-control" :class="classes">
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                                </validationProvider>
                            </div>
                            <ValidationProvider 
                                class="col-md-12" 
                                tag="div" 
                                name="Complemento lotérica"
                                v-slot="{ errors, ariaMsg, classes }"
                            >
                                <label :class="classes">Complemento</label>
                                <input id="complemento_lot"  type="text" v-model="form.complementoLoterica" class="form-control" :class="classes">
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                            </validationProvider>
                            <div class="row mx-0" style="margin-top:-10px">
                                <ValidationProvider 
                                class="col-md-6" 
                                rules="required" 
                                tag="div" 
                                name="Quantidade de terminais em funcionamento"
                                v-slot="{ errors, ariaMsg, classes }"
                                >
                                    <label :class="classes">Quantidade de terminais em funcionamento</label>
                                    <input id="terminais"  type="number" v-model="form.terminaisFuncionamento" class="form-control" :class="classes">
                                <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                                </validationProvider>
                                <ValidationProvider 
                                class="col-md-6" 
                                rules="required" 
                                tag="div" 
                                name="Valor médio mensal SITAE"
                                v-slot="{ errors, ariaMsg, classes }"
                                >
                                    <label :class="classes">Valor médio mensal SITAE</label>
                                    <select id="sitae"  class="form-control sitae" :class="classes" v-model="form.sitae">
                                
                                        <option selected="" >Escolha uma opção</option>
                                        <option value="Até R$9.999,99" >Até R$9.999,99</option>
                                        <option value="De R$10.000,00 Até R$14.999,99">De R$10.000,00 Até R$14.999,99</option>
                                        <option value="De R$15.000,00 a R$19.999,99">De R$15.000,00 a R$19.999,99</option>
                                        <option value="De R$20.000,00 a R$24.999,99">De R$20.000,00 a R$24.999,99</option>
                                        <option value="De R$25.000,00 a R$29.999,99">De R$25.000,00 a R$29.999,99</option>
                                        <option value="De R$30.000,00 a R$39.999,99">De R$30.000,00 a R$39.999,99</option>
                                        <option value="De R$40.000,00 a R$49.999,99">De R$40.000,00 a R$49.999,99</option>
                                        <option value="A partir de R$50.000,00">A partir de R$50.000,00</option>
                                    </select>
                                    <span v-bind="ariaMsg" :class="classes" class="spanError">{{ errors[0] }}</span>
                                </validationProvider>  
                            </div>
                       
                        
                        <div id="Send">
                            <button type="submit" class="color-white" id="Btn-send" :disabled="isBtnDisabled">{{StatusSendding}}</button>
                        </div>
                    </div>

                </div>
            </ValidationObserver>
        </div>
    </div>
</template>



<script>
    import Emojis from '@/components/EmojisWorkWithUs.vue';
    import $ from 'jquery';
    import { mask } from 'vue-the-mask'

    export default {
        directives: {
        mask,
        },
        data() {
            return {
                fileName:"(Nenhum arquivo)",
                StatusSendding:"Enviar",
                svgSending: false,
                isBtnDisabled: false,
                form:{
                    LogoUrl: "http://www.fasters.com.br/res/images/clientes/pontofacil.png",
                    MailTo: "comercial@pontofacil.com.br",
                    From:"",
                    FromName:"",
                    cpf:"",
                    rg:"",
                    Residencia:"",
                    numeroResidencia:"",
                    cepCasa:"",
                    complemento:"",
                    estadoCivil:"",
                    nomeLoterica:"",
                    enderecoLoterica:"",
                    numeroLoterica:"",
                    cepLoterica:"",
                    complementoLoterica:"",
                    terminaisFuncionamento:"",
                    sitae:"",
                    birthday:""
            }
            }
        },
        mounted() {
            this.$ga.page('/vagas');
            $( ".BigAnchor" ).click(function( event ) {
                event.preventDefault();
            });
          
        },
        components:{
            Emojis
        },
        methods: {  
            onSubmit() {
                this.$refs.formulario.validate().then(success => {
                    if(success){
                        var splitdate = this.form.birthday.split("-");
                        this.form.birthday = splitdate[2] + "/" + splitdate[1] + "/" + splitdate[0]
                        console.log(this.form)
                        this.svgSending = true;
                        this.btnText = "Enviando...";
                        this.isBtnDisabled = true;
                        this.form.message =
                        "<br> <strong> Nome completo: " + this.form.FromName + " </strong>"+
                        "<br> <strong> Endereço de email: " + this.form.From + " </strong>"+
                        "<br> <strong> CPF: " + this.form.cpf + " </strong>"+
                        "<br> <strong> RG: " + this.form.rg + " </strong>"+
                        "<br> <strong> Data de nascimento: " + this.form.birthday + " </strong>"+
                        "<br> <strong> Endereço residencial: " + this.form.Residencia + ", "+this.form.numeroResidencia + " CEP: " + this.form.cepCasa + " </strong>"+
                        "<br> <strong> Complemento residencial: " + this.form.complemento + " </strong>"+
                        "<br> <strong> Estado civil: " + this.form.estadoCivil + " </strong>"+
                        "<br> <strong> Nome da loterica: " + this.form.nomeLoterica + " </strong>"+
                        "<br> <strong> Endereço da loterica: " + this.form.enderecoLoterica + ", "+this.form.numeroLoterica + " CEP: " + this.form.cepLoterica +" </strong>"+
                        "<br> <strong> Complemento da loterica: " + this.form.complementoLoterica + " </strong>"+
                        "<br> <strong> Quantidade de terminais: " + this.form.terminaisFuncionamento + " </strong>"+
                        "<br> <strong> SITAE: " + this.form.sitae + " </strong>";

                        this.$http
                        .post("https://mail.fasters.com.br/api/send", this.form, {
                        headers: {
                            "Content-Type": "application/json"
                        }
                        })
                        .then(
                            response => { //eslint-disable-line no-var, no-unused-vars
                                this.$alert("Sua mensagem foi recebida com sucesso. Oportunamente entraremos em contato. Obrigado.");
                                this.btnText = "Enviar";
                                this.form = {};
                            
                                this.$ga.event({
                                eventCategory: "formCur",
                                eventLabel: "enviado",
                                eventAction: "enviar"
                                });
                                (this.isBtnDisabled = false);
                                this.svgSending = false;
                            },
                            response => {
                                this.$alert("Algo de errado aconteceu. Nossa equipe já está verificando. Tente novamente mais tarde.");
                                this.isBtnDisabled = false;
                                this.btnText = "Enviar";
                            
                            
                                this.svgSending = false;
                            }
                        );
                    }else{
                         this.$alert("Preencha os dados obrigátorios para enviar formulário");
                    }
                });    
            },
        },  
        
    }
</script>
<style scoped>
    label.failed{
        color:#dc3545;
    }
    *{
        transition-duration: 0;
        transition-timing-function: ease-in;
    }    
    h2{
        line-height: 1.25!important
    }     
    .selectinfVacancy{
        padding: 8px 25px;
        border-radius: 10px;
        font-size: 12px;
    }

    input {
        background-color: #fff;
        width: 100%;
        height: 50px;
        padding-left: 15px;
        text-align: left;
        border-radius: 10px;
    }

    input::placeholder{
        text-align: left;
    }

    .fileName{
        font-size: 10px;
    }

    .sharing{
        padding:8px 40px;
        border-radius: 10px;
        box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, .15);
        color: #175D93;
        font-size: 14px;
        margin: 5px 0;
    }


    .sharing:hover{
        background-color: rgba(23, 93, 147,75);
        color: rgba(255, 255, 255, .8);
        cursor: pointer;
    }

    #Send > button:hover{
        background-color: rgba(3, 73, 127);
    }
    

    .colCursor .target{
        padding: 15px 20px;        
    }

    .colCursor{
        background-color: #fff;
        margin: 15px 0;
        border-radius: 10px;
    }

    .colCursor h2{
        font-size: 14px;
        margin: 0;
        color: rgb(173, 173, 173);
    }

    .colCursor :hover{
        cursor: pointer;
    }

    .rotate{
        transform: rotateZ(180deg)
    }

    

    #workWithUs{
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#e0a638+1,f38235+100 */
        background: #e0a638; /* Old browsers */
        background: -moz-linear-gradient(45deg,  #e0a638 1%, #f38235 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(45deg,  #e0a638 1%,#f38235 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(45deg,  #e0a638 1%,#f38235 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0a638', endColorstr='#f38235',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
        padding-top: 100px;
    }

    h1{
        margin-bottom: 30px;
    }

    h3{
        font-size: 20px;
        padding: 15px 0;
    }

    .colCursor p{
        max-width: 100%;
        font-size: 12px;
        color: rgb(173, 173, 173);
        padding: 15px 20px 5px 20px;
        margin: 0
    }

    .anchoring{
        margin-top: 10px;
        padding: 10px 0 30px 20px;
    }

     label{
        font-size: 12px;
        top: -25px!important;
        color: #fff;
        font-weight: 700;
    }
    
    .first-camp{
        border-top: 2px solid rgba(255, 255, 255, 0.4);
        border-bottom: 2px solid rgba(255, 255, 255, 0.4);
        margin-bottom: 50px;
        padding: 20px 0;
    }

    .radiosCamp label{
        font-weight: normal;
        font-size: 14px;
        margin: 0 25px 0 5px
    }

    #Send > button{
        background-color: rgb(23, 93, 147);
        padding: 15px 50px;
        font-size: 14px;
        border-radius: 30px;
        margin-top: 25px;
    }

    .radiosCamp{
        margin-bottom: 30px;
    }

    .radiosCamp > div{
        margin-top: 25px;
    }

    .form-style{
        background-color: #fff;
        width: 100%;
        height: 50px;
        margin: 0 0 15px 0;
        padding-left: 15px;
        text-align: left;
        border-radius: 10px;
    }
    .sitae{
        background-color: #fff;
        width: 100% !important;
        height: 50px !important;
        text-align: left;
        border-radius: 10px;
    }
    

    input[type=radio] {
        width: 25px;
        height: 25px;
    }

    p.toDescriptions{
        font-size: 16px;
    }

    @media only screen and (max-width: 992px){
        .in-992{
            text-align: center;
        }

        #img_1 img{
            width: 100%;
        }
    }

    @media only screen and (max-width: 767px){
        p.toDescriptions{
            margin-right: 0px;
            text-align: center
        }
    }

</style>